<div class="col-12 col pb10 pt20">
    <div class="row col-12" style="min-height: 49px">
        <button id="button-create-edit-header-back" nz-button nzType="link" routerLink="{{ path }}" class="mr-32">
            <i nz-icon nzType="arrow-left"></i>
        </button>

        <!-- <div *ngIf="resource.icon2" class="mr-16 mr-sm-32 emh125">
        <i nz-icon [nzType]="resource.icon2"></i>
    </div> -->

        <div fxLayout="column" fxLayoutAlign="start start">
            <div [ngClass]="isSmallScreen ? 'h5' : 'h2'" *ngIf="headerParams.pageType === 'edit'">
                {{ editHeading$ | async }}
            </div>
            <div [ngClass]="isSmallScreen ? 'h5' : 'h2'" *ngIf="headerParams.pageType === 'new'">
                {{ newHeading | translate }}
            </div>
            <div [ngClass]="isSmallScreen ? 'h6' : 'subtitle secondary-text'">
                <span>{{ newSubHeading | translate }}</span>
            </div>
        </div>
    </div>
    <div class="col-12 row justify-end" style="margin-top: -20px">
        <ng-container [ngTemplateOutlet]="extraButtonTemplate"></ng-container>

        <button
            *ngIf="headerParams.pageType === 'new'"
            id="button-create-edit-header-add"
            nz-button
            nzType="primary"
            [nzLoading]="saving$ | async"
            [disabled]="headerParams.addDisabled$ | async"
            (click)="saveNewEntity()">
            <i nz-icon nzType="plus-circle"></i><span>{{ addButtonText | translate }}</span>
        </button>

        <button
            *ngIf="headerParams.pageType === 'edit'"
            id="button-create-edit-header-save"
            nz-button
            nzType="primary"
            [nzLoading]="saving$ | async"
            [disabled]="headerParams.editDisabled$ | async"
            (click)="saveEditedEntity()">
            <i nz-icon nzType="plus-circle"></i><span>{{ saveButtonText | translate }}</span>
        </button>

        <button
            *ngIf="
                headerParams.pageType === 'new' && headerParams.showSaveAndApproveButtonOnAdd && headerParams.showSaveAndApproveButtonOnAdd() === true
            "
            id="button-create-edit-header-save-approve"
            class="ml-16"
            nz-button
            [nzLoading]="saveAndApprove$ | async"
            [disabled]="headerParams.editDisabled$ | async"
            (click)="saveAndApproveNewEntity()">
            <i nz-icon nzType="save"></i><span>{{ addAndApproveButtonText | translate }}</span>
        </button>

        <button
            *ngIf="
                headerParams.pageType === 'edit' &&
                headerParams.showSaveAndApproveButtonOnSave &&
                headerParams.showSaveAndApproveButtonOnSave() === true
            "
            id="button-create-edit-header-save-approve"
            class="ml-16"
            nz-button
            [nzLoading]="saveAndApprove$ | async"
            [disabled]="headerParams.editDisabled$ | async"
            (click)="saveAndApproveEditedEntity()">
            <i nz-icon nzType="save"></i><span>{{ saveAndApproveButtonText | translate }}</span>
        </button>

        <button
            *ngIf="
                headerParams.pageType === 'new' &&
                headerParams.showSaveAndAllocateButtonOnAdd &&
                headerParams.showSaveAndAllocateButtonOnAdd() === true
            "
            id="button-create-edit-header-save-allocate-add"
            class="ml-16"
            nz-button
            nzType="primary"
            [nzLoading]="headerParams.saveAndAllocateLoading$ | async"
            [disabled]="headerParams.addDisabled$ | async"
            (click)="saveAndAllocateNewEntity()">
            <i nz-icon nzType="share-alt"></i><span>{{ saveAndAllocateButtonText | translate }}</span>
        </button>

        <button
            *ngIf="
                headerParams.pageType === 'edit' &&
                headerParams.showSaveAndAllocateButtonOnSave &&
                headerParams.showSaveAndAllocateButtonOnSave() === true
            "
            id="button-create-edit-header-save-allocate-edit"
            class="ml-16"
            nz-button
            nzType="primary"
            [nzLoading]="headerParams.saveAndAllocateLoading$ | async"
            [disabled]="headerParams.editDisabled$ | async"
            (click)="saveAndAllocateEditedEntity()">
            <i nz-icon nzType="share-alt"></i><span>{{ saveAndAllocateButtonText | translate }}</span>
        </button>

        <button
            *ngIf="headerParams.pageType === 'edit' && headerParams.showDelete"
            class="ml-16"
            nz-button
            nzType="primary"
            id="button-create-edit-header-delete"
            [nzLoading]="saving$ | async"
            [disabled]="headerParams.deleteDisabled$ | async"
            (click)="headerParams.deleteEntity()">
            <i nz-icon nzType="delete"></i><span>{{ deleteButtonText | translate }}</span>
        </button>
    </div>
</div>
